import MQTT from 'paho-mqtt';
import { appendOnboarding, setMetricscLoaded } from '../../features/session/sessionSlice';
import { store } from '../store';
import { WS_URL } from './common'

const client = new MQTT.Client(WS_URL, "clientId" + Math.floor(Math.random() * 10000))
try {

    client.connect({
        onSuccess:onConnect,
        useSSL: true
    });
    client.onMessageArrived = onMessageArrived;
} catch(e){
    console.log(e)
}

// called when the client connects
function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
}

async function onMessageArrived(message) {
    console.log("onMessageArrived:", JSON.parse(message.payloadString));
    if(message.destinationName.includes("onboarding")){
        await store.dispatch(appendOnboarding({
            loadingStatsProgress: 100,
            metricsLoaded: JSON.parse(message.payloadString).metricsLoaded
        }))
    }
}

export {
    client
}